// extracted by mini-css-extract-plugin
module.exports = {"PositiveAmount":"RowProwider_PositiveAmount__3ESdz","NegativeAmount":"RowProwider_NegativeAmount__2Br9v","Amount":"RowProwider_Amount__20UCO"};